<div class="wrapper d-flex align-items-stretch">
    <app-gestiones-header></app-gestiones-header>
    <app-gestiones-sidebar-menu></app-gestiones-sidebar-menu>
    <app-modulo-retencion-sidebar  (selecttab)="selecttab($event)"></app-modulo-retencion-sidebar>
    <app-retencion-inicativa (selecttab)="selecttab($event)" *ngIf="tabselected=='iniciativa'" style="width: 100%;height: 1000px; overflow-y: scroll;"></app-retencion-inicativa>
    <app-retencion-reportes (selecttab)="selecttab($event)" *ngIf="tabselected=='reportes'" style="width: 100%;height: 1000px; overflow-y: scroll;"></app-retencion-reportes>
</div>
